<template>
    <el-form :model="ruleForm" ref="ruleForm" class="demo-ruleForm">
        <div class="simple-form">
            <div class="form-group center">
                <div class="form-label">
                    <label class="required">审核操作</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="auditState">
                        <el-radio-group v-model="select" @change="setAudit">
                            <el-radio label="true">通过</el-radio>
                            <el-radio label="false">驳回</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </div>
            </div>
            <!--<div class="form-group center">-->
                <!--<div class="form-label">-->
                    <!--<label>&nbsp;</label>-->
                <!--</div>-->
                <!--<div class="form-value">-->
                    <!--<div class="pos-rel">-->
                        <!--<el-checkbox v-model="ruleForm.fiscalClearFlag" @change="setFiscalClear">自动清理</el-checkbox>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <!--<div class="form-group center" v-if="ruleForm.fiscalClearFlag">-->
                <!--<div class="form-label">-->
                    <!--<label>&nbsp;</label>-->
                <!--</div>-->
                <!--<div class="form-value width-1-5x">-->
                    <!--<div class="pos-rel">-->
                        <!--<el-checkbox v-model="ruleForm.devcClearFlag">自动清除</el-checkbox>-->
                    <!--</div>-->
                <!--</div>-->
            <!--</div>-->
            <div class="form-group center">
                <div class="form-label">
                    <label class="">原因</label>
                </div>
                <div class="form-value width-1-5x">
                    <el-form-item prop="desc">
                        <el-input type="textarea" v-model="ruleForm.desc"></el-input>
                    </el-form-item>
                </div>
            </div>
        </div>
    </el-form>
</template>

<script>
    import { Utils } from '../../app.base'
    import {MsgBox, Vue} from '../../app.vues'
    import assetVchrApi from "../../api/assetVchr";
    import{ openShopDeviceScrapItemViewDlg } from './selectDlg'

    export default {
        name: 'swb-shop-device-scrap-audit',
        desc: '报废单审核',
        props: {
            id: {
                type: Number,
                default: null
            },
        },
        data: function () {
            return {
                ruleForm: {
                    auditState: 1,
                    devcClearFlag: false,
                    fiscalClearFlag: false,
                    scrapVoucher: {}
                },
                select: "true"
            }
        },
        created: function () {
        },
        methods: {
            setAudit: function () {
                let ruleForm = this.ruleForm;
                if(this.select == "true") {
                    ruleForm.devcClearFlag = true;
                    ruleForm.fiscalClearFlag = true;
                    ruleForm.auditState = 1;
                } else {
                    ruleForm.devcClearFlag = false;
                    ruleForm.fiscalClearFlag = false;
                    ruleForm.auditState = -1;
                }
                this.ruleForm = Utils.merge({}, ruleForm);
            },
            setFiscalClear: function () {
                let ruleForm = this.ruleForm;
                if(Utils.isTrue(ruleForm.fiscalClearFlag)) {
                    ruleForm.devcClearFlag = true;
                    this.shopDeviceScrapItemView();
                } else {
                    ruleForm.devcClearFlag = false;
                }
            },
            shopDeviceScrapItemView : function(){
                //wangyazhe
                let self = this;
                openShopDeviceScrapItemViewDlg(function (result) {
                    self.ruleForm.scrapVoucher = Utils.merge({}, result);
                }, null, this.id, this.ruleForm.scrapVoucher);
            },
            getDlgResult: function () {
                let self = this;
                let result = {};
                if(!Utils.isTrue(self.ruleForm.fiscalClearFlag)) {
                    self.ruleForm.scrapVoucher = Utils.merge({}, {});
                }
                result.type = "info";
                result.data = self.ruleForm;
                return result;
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/scrapVoucher/ShopDeviceScrapVoucherAudit.vue